import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BlockUI, NgBlockUI } from 'ng-block-ui';



@Component({
  selector: '#app-root',
  providers: [
    Location,
    { provide: LocationStrategy, useClass: PathLocationStrategy },
  ],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  validDevice: number;
  databaseId: any;
  mod: string;

  @BlockUI() blockUI: NgBlockUI;
  constructor(private router: Router) {
  }

  ngOnInit() {
    this.router.navigate(['/layout/dashboard']);
  }
}
